'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initialize;

var _interfaces = require('./interfaces');

var interfaces = _interopRequireWildcard(_interfaces);

var _Suite = require('./Suite');

var _Suite2 = _interopRequireDefault(_Suite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function initialize(context) {
  var rootSuite = new _Suite2.default('');
  var suites = [rootSuite];
  interfaces.percy(context, suites);
  return rootSuite;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@percy/react-percy-test-framework/lib/index.js
// module id = 475
// module chunks = 1